import { PFlex, PFlexItem, PHeadline, PMarque, PText } from '@porsche-design-system/components-react'
import React from 'react'

import { TEXTS } from '../../shared/config/texts'

import { ReactComponent as PopUpField } from '../../shared/assets/popupfield.svg'
import styles from './authentication.module.css'

const Authentication = () => {
  return (
    <PFlex justifyContent='center' alignItems='center' className={styles.noUser}>
      <PFlexItem className={styles.login}>
        <PMarque />
        <PHeadline variant='headline-3' align='center' className={styles.title}>
          {TEXTS.UNAUTHENTICATED_PORTAL_NAME}
        </PHeadline>
        <PText align='center' className={styles.subTitle}>
          {TEXTS.UNAUTHENTICATED_TEXT}
        </PText>
        <PText align='center' className={styles.subTitle}>
          {TEXTS.UNAUTHENTICATED_SUB_TITLE}
        </PText>
        <PopUpField />
      </PFlexItem>
    </PFlex>
  )
}

export default Authentication
